import styled from 'styled-components'
import { theme } from '../../styles/theme'

export const Container = styled.div`
  width: 466px;
  padding: 35px 38px;
  float: right;

  background: ${theme.colors.mainBg};
  box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);
  border-radius: ${theme.border.mediumRadius};

  display: flex;
  flex-direction: column;

  & > h3 {
    font-family: ${theme.font.workSans};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.xlarge};
    line-height: ${theme.font.sizes.xxlarge};
    color: ${theme.colors.lightBrown};
  }

  & > img {
    width: 100%;
    margin: 15px auto;
  }

  & > ul > li {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.medium};
    font-size: ${theme.font.sizes.small};
    line-height: ${theme.font.sizes.normal};
    color: ${theme.colors.lightBrown};
  }
`
